
import { schema, normalize } from 'normalizr';

import { createActions, asyncAction } from '../helpers/redux';

const avatarSchema = new schema.Entity('avatars');
const userSchema = new schema.Entity('users');
const roleSchema = new schema.Entity('roles');

userSchema.define({
  avatar: avatarSchema,
});

const projectUserSchema = new schema.Entity('projectUsers', {
  user: userSchema,
  role: roleSchema,
}, {
  idAttribute(entity) {
    return entity.user.id;
  },
});

// projectUserSchema.define({
//   user: userSchema,
//   role: roleSchema,
// });

const pendingUserSchema = new schema.Entity('pendingUsers');

const projectUserAllSchema = new schema.Entity('projectUserAll', {
  projectUsers: [projectUserSchema],
  pendingUsers: [pendingUserSchema],
}, {
  idAttribute() {
    return 0;
  },
});

export const UserActions = createActions({
  @asyncAction()
  async getProjectUsers(projectId) {
    return ({ client }) =>
      client.get(`/projects/${projectId}/users`)
      .then(response => normalize(response, projectUserAllSchema));
  },

  @asyncAction()
  async updateAvatar(userId, avatarObject) {
    return ({ client }) => {
      const data = new FormData();
      data.append('file', avatarObject.avatar);
      console.log(avatarObject, data);
      return client.post(`/users/${userId}/avatar`, {
        body: data,
        formData: true,
//        headers: { 'Content-Type': 'multipart/form-data' },
      }).then(response => normalize(response, userSchema));
    }
  },

  @asyncAction()
  async deleteAvatar(userId, avatarId) {
    return ({ client }) => {
      return client.delete(`/users/${userId}/avatar`).then((response) => {
        // response.userId = userId;
        return response;
      });
    }
  },

  @asyncAction()
  async updateProfile(userId, profile) {
    return ({ client }) =>
      client.post(`/users/${userId}/profile`, {
        body: profile,
      }).then(response => normalize(response, userSchema));
  },

  @asyncAction()
  async changePassword(userId, password) {
    return ({ client }) =>
      client.post(`/users/${userId}/password`, {
        body: password,
      }).then(response => response);
  },

  @asyncAction()
  async resetPassword(hash, password) {
    return ({ client }) =>
      client.post(`/forgot/password/${hash}`, {
        body: password,
      }).then(response => response);
  },

  @asyncAction()
  async forgotPassword(email) {
    return ({ client }) =>
      client.post('/forgot/password', {
        body: { email },
      }).then(response => response);
  },

  @asyncAction()
  async changeEmail(userId, password) {
    return ({ client }) =>
      client.post(`/users/${userId}/email`, {
        body: password,
      }).then(response => response);
  },

  @asyncAction()
  async confirmEmail(hash) {
    // console.log('aaaa');
    return ({ client }) =>
      client.get(`/confirm/email/${hash}`).then(response => normalize(response, userSchema));
  },

  @asyncAction()
  async addProjectUser(projectId, user) {
    return ({ client }) =>
      client.post(`/projects/${projectId}/users/add`, {
        body: user,
      }).then(response => normalize(response, projectUserAllSchema));
  },

  @asyncAction()
  async register(user) {
    return ({ client }) =>
      client.post(`/register/${user.hash}`, {
        body: user,
      }).then(response => response);
  },
});



// WEBPACK FOOTER //
// ./src/actions/user.js